import {Trans} from '@lingui/macro';
import React from 'react';

import {
  VirtualTableColumnCellsEnum,
  virtualTableRowCheckboxWrapperWidth,
} from '../../../components/common/table/helpers/tableHelpers';
import {getServerAuthenticationStrategyLabel} from '../../../models/api/serverHelpers';
import {ServerModel} from '../../../models/api/serverModel';
import {ResourceColumn, ResourceTableColumnTypesEnum} from '../commons/resourceTableTypes';

export enum ServersTableColumnIdsEnum {
  ORIGIN = 'origin',
  AUTHENTICATION_CONFIG_STRATEGY = 'authenticationConfigStrategy',
  CREATED_DATE = 'created_date',
}

export const serversTableColumns: ReadonlyArray<ResourceColumn<ServerModel>> = [
  {
    id: ServersTableColumnIdsEnum.ORIGIN,
    type: ResourceTableColumnTypesEnum.TEXT,
    title: <Trans id="servers-table-column-origin">Origin</Trans>,
    accessor: (server) => server.origin,
    cellType: VirtualTableColumnCellsEnum.TEXT,
    settings: {
      sticky: {
        isSticky: true,
        stickyOffset: virtualTableRowCheckboxWrapperWidth,
      },
      cellWidth: {
        shouldFillRemainingWidth: true,
      },
    },
  },
  {
    id: ServersTableColumnIdsEnum.AUTHENTICATION_CONFIG_STRATEGY,
    type: ResourceTableColumnTypesEnum.TEXT,
    title: <Trans id="servers-table-column-authentication-strategy">Authentication strategy</Trans>,
    accessor: (server) => getServerAuthenticationStrategyLabel(server.authenticationConfig.strategy),
    cellType: VirtualTableColumnCellsEnum.TEXT,
    settings: {
      cellWidth: {
        width: 200,
      },
    },
  },
];
